var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--join"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "join-title"
  }, [_vm._v("회원가입")]), _c('div', {
    staticClass: "join-container"
  }, [_c('div', {
    staticClass: "join-gate"
  }, [_c('div', {
    staticClass: "join-gate-box join-gate-box--personal"
  }, [_c('div', {
    staticClass: "join-gate-box__inner"
  }, [_c('h2', [_vm._v("개인회원")]), _c('i', {
    staticClass: "icon icon-chair"
  }), _c('dialog-join', {
    attrs: {
      "userType": _vm.PERSON.value
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 가입하기 ")])];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "join-gate-box join-gate-box--business"
  }, [_c('div', {
    staticClass: "join-gate-box__inner"
  }, [_c('h2', [_vm._v("기업회원")]), _c('i', {
    staticClass: "icon icon-picture"
  }), _c('dialog-join', {
    attrs: {
      "userType": _vm.COMPANY.value
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 가입하기 ")])];
      }
    }])
  })], 1)])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }